import App from './App';
import { router } from './router';
import store from  './store'
import Vue from 'vue';
import http from './utils/axios';

let instance = http();
Vue.prototype.$http=instance
//配置baseUrl
instance.defaults.baseURL = '/api'

import { Cell, CellGroup} from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);


import { Field } from 'vant';
Vue.use(Field);

import { RadioGroup, Radio } from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);





new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
